import React from "react";
import { Button, Chip, Table } from "../../../../components/core";
import { useMatch } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { DELETE_PARTNER_BRANCH_ASSIGNMENT } from "../../../../constants/graphql/locker-queries";

export default function OutputTable({
	classname,
	items,
	headers,
	refetch,
	onDelete,
	branch,
	lockerType,
	partner,
	handleAddAgentClick,
	disabled = false,
}) {
	const [deletePartnerBranchAssignment] = useMutation(
		DELETE_PARTNER_BRANCH_ASSIGNMENT
	);
	const onHadleDelete = (event, partnerBranchAssignmentId, doorsOccupied) => {
		onDelete(event, partnerBranchAssignmentId, doorsOccupied);
	};
	return (
		<div className="bg-gray-100 p-2">
			<p className="font-bold text-xl my-4 text-center">
				Current {lockerType} Locker Assignment:
			</p>
			<p className="font-bold text-xl my-4 text-center">
				{partner} : {branch}
			</p>
			<table className="w-full">
				<tr className="bg-primary-primaryYellow h-16">
					{headers.map((data, key) => {
						return (
							<th className="text-left p-2" key={key}>
								{key === 0 ? lockerType : ""} {data.header_name}
							</th>
						);
					})}
					<th className="text-left p-2"></th>
				</tr>
				{items.map((data, key) => {
					return (
						<tr className="h-12 even:bg-gray-100 bg-white">
							{headers.map((headerData, headerKey) => {
								if (Array.isArray(data[headerData.header_key])) {
									return (
										<td
											className="px-2 py-4 border-b-2 border-stone-400"
											key={headerKey}
										>
											{data[headerData.header_key].map(
												(agentData, agentKey) => {
													if (agentData.agentName.includes("None")) {
														return (
															<p className="text-center font-bold text-red-500">
																No Agent Assigned.
															</p>
														);
													}
													return (
														<Chip
															disabled={disabled}
															className="m-2"
															label={`${agentData.agentName
																.substring(0, agentData.agentName.indexOf("("))
																.trim()}`}
															key={agentKey}
															onDelete={(event) =>
																onHadleDelete(
																	event,
																	agentData.partnerAgentAssignmentId
																)
															}
														/>
													);
												}
											)}
										</td>
									);
								}
								return (
									<td
										className="px-2 py-4 border-b-2 border-stone-400"
										key={headerKey}
									>
										{data[headerData.header_key]}
									</td>
								);
							})}
							<td className="px-2 py-4 border-b-2 border-stone-400">
								<Button
									value={`Add agent`}
									disabled={disabled}
									className={"p-2"}
									onClick={() => {
										handleAddAgentClick(data);
									}}
								/>
							</td>
						</tr>
					);
				})}
			</table>
		</div>
	);
}
